import {
  Component,
  EventEmitter,
  HostListener,
  OnInit,
  Output,
} from '@angular/core';
import {
  ActivatedRoute,
  NavigationEnd,
  Router,
  RouterModule,
  RouterOutlet,
} from '@angular/router';
import { CommonModule } from '@angular/common';
import { SigninComponent } from '../auth/signin/signin.component';
import { LoginService } from '../../services/login.service';
import { Themeservice } from '../../services/theme.service';
import { ProfileService } from '../../../shared/services/profile.service';
import { Observable, filter, of, switchMap } from 'rxjs';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { debounceTime, distinctUntilChanged, tap } from 'rxjs/operators';
import { socket } from '../../../shared/helpers/socketio';

interface sideNavToggle {
  screenWidth: number;
  collapsed: boolean;
}
@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    CommonModule,
    SigninComponent,
    RouterOutlet,
    RouterModule,
    FormsModule,
  ],
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss',
})
export class SidebarComponent implements OnInit {
  @Output() onToggleSideNav: EventEmitter<sideNavToggle> = new EventEmitter();
  screenWidth = 0;
  collapsed = false;
  themes = ['classic', 'dark', 'light', 'morden', 'transparnet'];
  currentTheme: string;
  logoUrl: string = '/assets/logo/chessx-light-main-logo.svg';
  navbarHomepage: string = 'homepage-color';
  settingDropdown = 'dropdown-home-bg';
  navbarBgcolor = '';
 

  constructor(
    private router: Router,
    private signIn: LoginService,
    private activatedRoute: ActivatedRoute,
    private themeService: Themeservice
  ) {
    this.themes = this.themeService.getThemes();
    this.currentTheme = this.themeService.getCurrentTheme();
    this.updateLogo(this.themeService.getTheme());
  }

  @HostListener('window:resize', ['$event'])
  @HostListener('window:scroll', ['$event'])
  onResize(event: any) {
    this.screenWidth = window.innerWidth;
    if (this.screenWidth <= 768) {
      this.collapsed = false;
      this.onToggleSideNav.emit({
        collapsed: this.collapsed,
        screenWidth: this.screenWidth,
      });
    }
  }

  ngOnInit(): void {


    this.screenWidth = window.innerWidth;
    this.themeService.themeSubject.subscribe((res) => {
      this.updateLogo(res);
    });

    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: any) => {
        this.updateNavbarClass();
        this.handleRouteChange();
      });

    this.updateNavbarClass();
    this.handleRouteChange();
  }




  private updateNavbarClass() {
    if (this.router.url === '/') {
      this.navbarHomepage = 'homepage-color';
      this.settingDropdown = 'dropdown-home-bg';
      this.logoUrl = '/assets/logo/chessx-light-main-logo.svg';
    } else {
      this.navbarHomepage = 'without-homepage-color';
      this.settingDropdown = 'dropdown-all-bg';
      if (
        localStorage.getItem('theme') == 'light' ||
        localStorage.getItem('theme') == 'classic'
      ) {
        this.logoUrl = '/assets/logo/chessx-dark-main-logo.svg';
      }
    }

    if (!this.loggedin()) {
      if (this.router.url === '/') {
        this.navbarBgcolor = 'without-login-homepage';
      } else {
        this.navbarBgcolor = 'login-homepage';
      }
    }
  }

  private handleRouteChange() {
    const currentRoute = this.activatedRoute.root;
  }

  toggleCollapse() {
    this.collapsed = !this.collapsed;
    this.onToggleSideNav.emit({
      collapsed: this.collapsed,
      screenWidth: this.screenWidth,
    });
  }

  closeSideNav() {
    this.collapsed = false;
    this.onToggleSideNav.emit({
      collapsed: this.collapsed,
      screenWidth: this.screenWidth,
    });
  }

  loggedin() {
    return localStorage.getItem('loggedInUser');
  }

  onLogout() {
    this.signIn.logoutUser().subscribe({
      next:(res)=>{
      }
    });
    this.signIn.logout();
        // window.location.href = this.router.url;
  }

  selectedsideNav() {
    this.collapsed = false;
  }

  switchTheme(event: any): void {
    const selectedTheme = event.target.value;
    this.themeService.setTheme(selectedTheme);
    this.currentTheme = selectedTheme;
  }

  closeMenu(menuToggle: HTMLInputElement) {
    menuToggle.checked = false;
  }

  updateLogo(theme: string) {
    if (theme === 'classic' || theme === 'light') {
      this.logoUrl = '/assets/logo/chessx-dark-main-logo.svg';
    } else {
      this.logoUrl = '/assets/logo/chessx-light-main-logo.svg';
    }
  }

  profilePageRoute() {
    const loginuser=JSON.parse(localStorage.getItem('loggedInUser') || '{}'); 
    this.router.navigate(['/profile',loginuser?.username]);
  }
}
